<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    let element: HTMLElement

    let translateX = 0

    const dispatch = createEventDispatcher()

    onMount(() => {
        const rect = element.getBoundingClientRect()
        if (rect.right > window.innerWidth) {
            translateX = window.innerWidth - rect.right
        }
    })
</script>

<div
    class="popup"
    style="--translateX:{translateX}px;"
    transition:fade={{ duration: 200 }}
    bind:this={element}
>
    <div class="close" on:click={() => dispatch('dismiss')} />
    <div class="content">
        <slot />
    </div>
</div>

<style lang="scss">
    .popup {
        position: absolute;
        bottom: calc(100% + 2.5rem);
        left: clamp(0px, 2rem, 40%);
        transform: translate(var(--translateX));
        width: 20rem;
        max-width: calc(100vw - 3rem);
        background-color: var(--color-gray);
        border-radius: 0.3125rem;
        padding: 2rem 1.5rem;
        line-height: 1.5em;
        color: white;
        .close {
            position: absolute;
            background-color: white;
            height: 1.5rem;
            width: 1.5rem;
            mask-image: url('/plus-ewiko/wp-content/themes/ewiko/assets/images/modal-close.svg');
            mask-size: contain;
            mask-repeat: no-repeat;
            top: 0.5rem;
            right: 0.5rem;
            cursor: pointer;
            z-index: 10;
        }
        &::before {
            content: '';
            position: absolute;
            top: 100%;
            left: 0;
            height: 0;
            width: 0;
            border-left: solid 4.5rem var(--color-grey);
            border-top: solid 3rem transparent;
            border-bottom: solid 3rem transparent;
            transform: translateX(calc(-1 * var(--translateX))) translateY(-50%);
            z-index: 9;
        }
        .content {
            max-height: 300px;
            overflow-y: scroll;
        }
    }
</style>
